import { section } from "@/glow";
import AccountLogin from "@/lib/account/login";

section("login", {
  onLoad() {
    this.accountLogin = AccountLogin(this.container);
  },

  onUnload() {
    this.accountLogin?.unload();
  },
});
